import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import CookieNotice from '@/components/layout/CookieNotice'
import MetaPixel from '@/components/marketing/MetaPixel'
import PublicHeader from '@/components/layout/PublicHeader'
import Footer from '@/components/layout/Footer'
import LoadingSpinner from '@/components/ui/LoadingSpinner'

const PublicLayout = () => {
  return (
    <div className="marketing-surface flex min-h-screen flex-col">
      <MetaPixel />
      <PublicHeader />

      <main className="flex-1">
        <Suspense
          fallback={
            <div className="flex min-h-[40vh] items-center justify-center">
              <LoadingSpinner />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </main>

      <Footer />
      <CookieNotice />
    </div>
  )
}

export default PublicLayout
